// extracted by mini-css-extract-plugin
module.exports = {"saveSearchModal":"_3gq10XbJ","saveSearchTitle":"_3vVuQ3G9","saveSearchInput":"GVfqUe_l","saveSearchButtons":"_2wg08K5x"};
    if(module.hot) {
      // 1746735816356
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  